import React from 'react';

const SvgLt = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="LT_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="LT_svg__b" fill="#fff">
        <use xlinkHref="#LT_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#LT_svg__a" />
      <path fill="#118357" mask="url(#LT_svg__b)" d="M0 6.667h28v6.667H0z" />
      <path fill="#D8343D" mask="url(#LT_svg__b)" d="M0 13.333h28V20H0z" />
      <path fill="#FEC34B" mask="url(#LT_svg__b)" d="M0 0h28v6.667H0z" />
    </g>
  </svg>
);

export default SvgLt;
